export const iconFontAwesomeFoodBeverageWineGlassEmpty = (
	<i className="fa-solid fa-wine-glass-empty"></i>
);
